import { CreditCardFlag } from 'components/atoms/CreditCardFlag';
import React from 'react';
import { maskCurrencyFormat } from 'util/masks';

import { Grid, Stack, Typography } from '@mui/material';

interface Props {
  planTitle: string;
  planPrice: number;
  creditCardTitle: string;
  creditCardDescription: string;
  installmentText: string;
}

export const TutorPlanOrderResumeCreditCard: React.FC<Props> = ({
  planTitle,
  planPrice,
  creditCardTitle,
  creditCardDescription,
  installmentText,
}) => {
  return (
    <Grid item xs={12} md={4} spacing={2}>
      <Stack spacing={2} direction="row" alignItems="flex-start">
        <CreditCardFlag width={34} alt="Ícone cartão" cardFlag="visa" />

        <Stack spacing={1} direction="column">
          <Stack direction="row" justifyContent="space-between" mt={0.5}>
            <Typography color="#4B4B4B" fontSize={14} fontWeight={700}>
              {planTitle}
            </Typography>

            <Typography color="#4B4B4B" fontSize={14} fontWeight={400}>
              {maskCurrencyFormat(planPrice)}
            </Typography>
          </Stack>

          <Typography color="#4B4B4B" fontSize={14} fontWeight={400}>
              {installmentText ?? ''}
          </Typography>

          <Typography color="#4B4B4B" fontSize={12} fontWeight={400}>
            {creditCardTitle}
          </Typography>

          <Typography color="#4B4B4B" fontSize={12} fontWeight={400}>
            {creditCardDescription}
          </Typography>
        </Stack>
      </Stack>
    </Grid>
  );
};
